import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import VideoIntro from './components/VideoIntro';
import Services from './components/Services';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Logos from './components/Logos';
import CalendlyWidget from './components/CalendlyWidget';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';

function App() {
  return (
    <div style={{ minHeight: '100vh' }}>
      <Header />
      <Hero />
      <VideoIntro />
      <Services />
      <About />
      <Testimonials />
      <Logos />
      <CalendlyWidget />
      <Newsletter />
      <Footer />
    </div>
  );
}

export default App;
